import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { useCurrenciesStore } from '../stores/currenciesStore';

export const useShipmentCalculation = () => {
    const [activeCalculation, setActiveCalculation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const {selectedCurrency, currencies} = useCurrenciesStore.getState()

    const fetchActiveCalculation = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axiosInstance.get('/api/shipment-calculations/active');
            setActiveCalculation(response.data.data);
        } catch (err) {
            console.error('Error fetching active shipment calculation:', err);
            setError(err.message || 'Failed to fetch active shipment calculation');
        } finally {
            setLoading(false);
        }
    };

    const calculate = (payload) => {
        if (!activeCalculation) {
            throw new Error('No active calculation method available');
        }
        
        // Calculate price based on the calculation ID
        switch (activeCalculation.id) {
            case 'province_and_municipality':
                return calculateProvinceAndMunicipality(payload);
            default:
                throw new Error(`Unsupported calculation method: ${activeCalculation.id}`);
        }
    };

    const calculateProvinceAndMunicipality = (payload) => {
        const currency = currencies.find(item => item.short_name === selectedCurrency)
        const { province, municipality } = payload;

        if (!province || !municipality) {
            throw new Error('Province and municipality are required');
        }

        const calculationData = activeCalculation.calculation_data

        if(!calculationData) {
            throw new Error('Calculation data not found');
        }

        const provinceData = calculationData.find(item => item.province === province);

        if(!provinceData) {
            throw new Error('Province not found');
        }

        const municipalityData = provinceData.municipalities.find(item => item.name === municipality);

        if(!municipalityData) {
            throw new Error('Municipality not found');
        }

        let basePrice = provinceData.price;
        if (municipalityData.price !== undefined && municipalityData.price !== null) {
            basePrice = municipalityData.price;
        }

        if(currency && currency.main) {
            return basePrice
        }

        // Check for manual price in municipality
        if (municipalityData.manual_prices && municipalityData.manual_prices.find(item => item.currency_id === currency.id)) {
            return municipalityData.manual_prices.find(item => item.currency_id === currency.id).value;
        }

        // Check for manual price in province 
        if (provinceData.manual_prices && provinceData.manual_prices.find(item => item.currency_id === currency.id)) {
            return provinceData.manual_prices.find(item => item.currency_id === currency.id).value;
        }

        // If no manual price, calculate using exchange rate
        const exchangeRate = currency.exchange_rate;
        return basePrice * exchangeRate;
    };

    return {
        activeCalculation,
        loading,
        error,
        calculate,
        fetchShipmentCalculation: fetchActiveCalculation
    };
}; 

export const useProvinceAndMunicipality = (calculation = null) => {
    const [selectedProvince, setSelectedProvince] = useState(null)
    const [provinces, setProvinces] = useState([])
    const [municipalities, setMunicipalities] = useState([])
    
    useEffect(() => {
        if (calculation) {
            console.log('get provinces')
            getProvinces()
        }
    }, [calculation])

    useEffect(() => {
        console.log('get municipalities')
        getMunicipalities(selectedProvince)
    }, [selectedProvince])

    const getProvinces = () => {
        if (!calculation || !calculation.calculation_data) {
            return [];
        }

        console.log('calculation', calculation)
        
        setProvinces(calculation.calculation_data.map(item => item.province))
    };
    
    const getMunicipalities = (province) => {
        if (!calculation || !calculation.calculation_data || !province) {
            return [];
        }
        
        const provinceData = calculation.calculation_data.find(
            item => item.province === province
        );
        
        if (!provinceData || !provinceData.municipalities) {
            return [];
        }
        
        setMunicipalities(provinceData.municipalities.map(item => item.name))
    };
    
    return {
        provinces,
        municipalities,
        setSelectedProvince,
    };
};